module.exports = __webpack_public_path__ + "img/builder-6.fd13af2e.webp";